import React, { useMemo, useState, VFC } from 'react';
import T from 'i18n-react';
import moment from 'moment';
import { LOCAL_STORAGE_SCHEDULE_SNACKBAR_KEY } from '~/src/core/localStorages';
import { SCHEDULE_SNACKBAR_EXPIRING_DURATION } from '../constants';
import makeStyles from '@material-ui/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import { USER_SCHEDULES } from '../../../routing';

const useStyles = makeStyles((theme: Theme) => ({
  snackbarContentRoot: {
    padding: 0,
  },
  snackbarContentMessage: {
    width: '100%',
    padding: 0,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    padding: '6px 16px',
    color: 'white',
  },
  link: {
    color: 'white',
    '&:hover': {
      color: 'white',
    },
  },
  iconButton: {
    marginLeft: theme.spacing(1),
  },
  icon: {
    color: 'white',
  },
}));

const TransitionUp = (props) => {
  return <Slide {...props} direction="up" />;
};

interface Props {}

const ScheduleSnackbar: VFC<Props> = () => {
  // useMemoを使うことで、変数のように扱う
  const defaultOpen = useMemo(() => {
    const lastDisplayDate = localStorage.getItem(
      LOCAL_STORAGE_SCHEDULE_SNACKBAR_KEY,
    );
    if (!lastDisplayDate || !moment(lastDisplayDate).isValid()) return true;

    const diff = moment().diff(moment(lastDisplayDate), 'hours');
    // localStorageの値の期限内の場合、falseを返す
    return diff > SCHEDULE_SNACKBAR_EXPIRING_DURATION;
  }, []);

  const classes = useStyles();
  const [open, setOpen] = useState(defaultOpen);

  const setLocalStorage = () =>
    localStorage.setItem(
      LOCAL_STORAGE_SCHEDULE_SNACKBAR_KEY,
      moment().toISOString(),
    );

  const handleClose = () => {
    setOpen(false);
    setLocalStorage();
  };

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      TransitionComponent={TransitionUp}
      message={
        <div className={classes.container}>
          <Link
            href={USER_SCHEDULES}
            classes={{ root: classes.link }}
            onClick={handleClose}
            underline="always"
          >
            {T.translate('header.scheduleSnackbar.text')}
          </Link>
          <IconButton
            size="small"
            onClick={handleClose}
            classes={{ root: classes.iconButton }}
          >
            <CloseIcon classes={{ root: classes.icon }} />
          </IconButton>
        </div>
      }
      ContentProps={{
        classes: {
          root: classes.snackbarContentRoot,
          message: classes.snackbarContentMessage,
        },
      }}
    />
  );
};

export default ScheduleSnackbar;
